<script>

import gsap from "gsap"
import ConstMatter from '@/core/mixins/ConstMatterPixi'
import Matter from 'matter-js'
import Settings from './Settings.js'
// import { GlowFilter } from 'pixi-filters'
export default {
  name: 'Form',
  mixins: [ ConstMatter ],
  props: ['data', 'level', 'indice'],
  render: h => h(),

  beforeDestroy() {
    this.removeChild()
  },

  created() {
    this.$object = {
      body: null,
      sprite: null,
      constraint: null
    }
  },

  mounted() {


    this.$locked = false
    this.name = this.data.key

    this.$positions = [ { x: .0, y: -1.2 }, { x: .30, y: -1 }, { x: -.70, y: .65 }, { x: -.12, y: .40 }, { x: .80, y: .35 }, { x: -.80, y: 0 }, { x: -.58, y: -.50 } ]
    this.$Vertices = Matter.Vertices

    this.$specs = this.data
    this.$specs.x = this.$positions[0]['x']
    this.$specs.y = this.$positions[0]['y']

    this.$specs.angle = _.random(0, 0.02)

    // if(!this.$debug) 
    //   this.getSpriteObject(this.$specs)  

    this.createVerticesObject(this.$specs)
    // if(this.shape === this.name) this.hideSprite() 


     gsap.delayedCall(3.5, ()=> this.removeChild())

  },

  methods: {

    // useOrganic() {
    //   if(!this.$img.position) return
    //   const tp = _.random(1,3.5)
    //   const px = _.random(-5,5)
    //   const py = _.random(-5,5)
    //   const sc = _.random(0.85, 1.1)*this.$ratio
    //   this.$motion = TweenMax.to(this.$img.position, tp, {  x: px, y: py, ease: Linear.easeNone })
    //   this.$scale = TweenMax.to(this.$img.scale, tp*0.95, {  x: sc, y: sc, ease: Linear.easeNone, onComplete: ()=>{ this.useOrganic() } })
    //   this.$alpha = TweenMax.to(this.$bkg, _.random(0.5, 0.95)*tp, {  alpha: _.random(0.35, 1), ease: Linear.easeNone })
    //   this.stimule(_.random(0, 0.35))
    // },

    // stimule(coef) {
    //   if(this.$object.body) {
    //     this.$object.body.position.x += _.random(-coef, coef)
    //     this.$object.body.position.y += _.random(-coef, coef)
    //   }
    // },

    // hideSprite() {
    //   const coef = 0.25
    //   this.$img.filters = [this.$glow]
    //   TweenMax.to(this.$sprite, 0.5*coef, { alpha: 0, delay: 0.2 })
    //   TweenMax.to(this.$bkg, 0.75*coef, { alpha: 1, delay: 0 })
    //   TweenMax.to(this.$img.scale, 0.5*coef, { x: 0.2, y: 0.2, delay: 0.2 })
    //   this.$tween = TweenMax.delayedCall(1*coef, () =>{
    //     this.$object.body.isSensor = true
    //     this.$tween = null
    //   })
    //   TweenMax.delayedCall(0.5, ()=>{ this.$locked = true })
    // },

    // showSprite() {
    //   if(this.$tween) this.$tween.kill()
    //   if(this.$scale) this.$scale.kill()
    //   this.$img.filters = []
    //   TweenMax.to(this.$sprite, 0.5, { alpha: 1, delay: 0.2 })
    //   TweenMax.to(this.$bkg, 0.5, { alpha: 1, delay: 0.5 })
    //   TweenMax.to(this.$img.scale, 0.5, { x: this.$ratio, y: this.$ratio, delay: 0.2, onComplete: ()=>{ this.useOrganic() } })
    //   this.$object.body.isSensor = false
    //   this.$locked = false
    // },

    removeChild() {

      // console.log('removeChild');

      if(this.$tween) this.$tween.kill()
      if(this.$motion) this.$motion.kill()
      if(this.$scale) this.$scale.kill()
      if(this.$alpha) this.$alpha.kill()
      this.$events.removeListener('animate', this.animate)
      if(this.$sprite) {
        this.$sprite.destroy()
        this.$parent.$container.removeChild(this.$sprite)
        this.$sprite = null
      }
      this.$World.remove(this.$world, [ this.$object.body ])
      this.$object = {}
    },

    createVerticesObject(specs) {

      const vector = this.$Vertices.fromPath(specs.path)
      // const body = this.$Bodies.fromVertices(this.$parent.getX(specs.x), this.$parent.getY(specs.y), vector, { name: this.name, 

      //           // frictionAir: 0.1,
      //           restitution: .9,

      //           // friction: 0.0001,

      //           isStatic: false



      //  } )


      const body = this.$Bodies.rectangle(this.$parent.getX(specs.x), this.$parent.getY(specs.y), 100, 100, {
            // slop: 0.05,
            // friction: .3,
            // frictionStatic: Infinity,
            restitution: .9,
            isStatic: false
        });



            body.angle = specs.angle

           // console.log(body);


             // density: 0.0005,
             //    frictionAir: 0.06,
             //    restitution: 0.3,
             //    friction: 0.01,

          // console.log(this.name);

      this.$bodies.push(body)
      this.$World.add(this.$world, [ body ])
      this.$names[this.name] = body
      this.$object.body = body
      // this.$events.on('animate', this.animate)
      // this.$Body.scale(this.$object.body, this.$ratio, this.$ratio)
      // this.addConstraint(specs, body)
    },

    addConstraint(specs, body) {
      this.$constraint = this.$Constraint.create({
        pointA: { x: this.$parent.getX(specs.x), y: this.$parent.getY(specs.y) },
        bodyB: body,
        pointB: { x: -10, y: -10 },
        stiffness: 0.001,
        damping: 0.05
      })
      this.$World.add(this.$world, [ this.$constraint ])
    },

    removeConstraint() {
      this.$World.remove(this.$world, [ this.$constraint ])
    },

    // getSpriteObject(specs) {
    //   this.$sprite = new PIXI.Sprite()
    //   this.$sprite.anchor.x = 0.5
    //   this.$sprite.anchor.y = 0.5
    //   this.$sprite.position.x = this.$parent.getX(specs.x)
    //   this.$sprite.position.y = this.$parent.getY(specs.y)
    //   this.$bkg = new PIXI.Sprite(new PIXI.Texture.fromImage(require('./img/glow.png')))
    //   this.$bkg.anchor.x = 0.5
    //   this.$bkg.anchor.y = 0.5
    //   this.$bkg.alpha = 0
    //   this.$bkg.scale.set(this.$ratio, this.$ratio)
    //   this.$sprite.addChild(this.$bkg)

    //   // this.$img = new PIXI.Sprite(new PIXI.Texture.fromImage(specs.image.sizes.large))
    //   // this.$img.anchor.x = 0.5
    //   // this.$img.anchor.y = 0.5
    //   // this.$img.scale.set(this.$ratio, this.$ratio)
    //   // this.$sprite.addChild(this.$img)

    //   this.$img = new PIXI.Sprite()
    //   this.$img.scale.set(this.$ratio, this.$ratio)
    //   this.$img.anchor.x = 0.5
    //   this.$img.anchor.y = 0.5
    //   this.$sprite.addChild(this.$img)

    //   // const large = new PIXI.Sprite(new PIXI.Texture.fromImage(specs.image.sizes.large))
    //   // large.anchor.x = 0.5
    //   // large.anchor.y = 0.5
    //   // large.cacheAsBitmap = true
    //   // this.$img.addChild(large)

    //   this.$glow = new GlowFilter
    //   this.$parent.$container.addChild(this.$sprite)
    //   this.$object.sprite = this.$sprite

    //   this.loadImage(specs.image.sizes.large).then(() => {
    //     this.$large = new PIXI.Sprite(new PIXI.Texture.fromImage(specs.image.sizes.large))
    //     this.$large.anchor.x = 0.5
    //     this.$large.anchor.y = 0.5
    //     this.$img.addChild(this.$large)
    //     this.appear()
    //   })
    // },

    // loadImage(url) {
    //   return new Promise((resolve, reject) => {
    //     if(PIXI.loader.resources[url]) return resolve()
    //     // PIXI.loader.add(url, url)
    //     PIXI.loader.load(resolve)
    //   })
    // },

    animate() {
      if(!this.$object.sprite) return
      if(!this.$object.body) return

      if(!this.$locked) {
        this.$object.sprite.position.x = this.$object.body.position.x
        this.$object.sprite.position.y = this.$object.body.position.y
      }
      this.$object.sprite.rotation = this.$object.body.angle
    },

    // appear() {
    //   const tempo = _.random(1, 2.5)
    //   const delay = _.random(1, 1.5)
    //   this.$img.scale.set(0, 0)
    //   TweenMax.to(this.$bkg, 1, { alpha: 1, delay: 1, ease: Linear.easeNone })
    //   TweenMax.to(this.$img.scale, tempo, { x: this.$ratio, y: this.$ratio, ease: Elastic.easeOut, delay: delay, onComplete: ()=>{
    //       this.$large.cacheAsBitmap = true
    //       this.useOrganic()
    //     }
    //   })
    // },

  },

  // watch: {
  //   shape(nw, od) {
  //     if(nw === this.name) this.hideSprite()
  //     else if(od === this.name) this.showSprite()
  //   },  
  // },

  // computed: {
  //   shape() { return this.$store.getters['user/shape'] }
  // }


}
</script>

















